import { UserAgentParser } from '@/utils/browser/user-agent-parser';

// iOS browsers all report "Safari" in the UA; the vendor token names the real one (tracking only).
// Don't move this into UserAgentParser: the player relies on it returning Safari to pick FairPlay DRM.
const IOS_BROWSER_TOKENS: [RegExp, string][] = [
    [/CriOS\/([\d.]+)/, 'Chrome'],
    [/FxiOS\/([\d.]+)/, 'Firefox'],
    [/EdgiOS\/([\d.]+)/, 'Edge'],
];

export const getBrowserNameVersion = (
    ua?: string,
): { browserName: string; browserVersionNumber: string } => {
    if (!ua) {
        return {
            browserName: '',
            browserVersionNumber: '',
        };
    }
    for (const [pattern, browserName] of IOS_BROWSER_TOKENS) {
        const browserVersionNumber = pattern.exec(ua)?.[1];
        if (browserVersionNumber) {
            return { browserName, browserVersionNumber };
        }
    }
    const userAgentParser = UserAgentParser.getInstance(ua);
    const { browser, browserVersionNumber } = userAgentParser.parseUserAgentString();
    return {
        browserName: browser,
        browserVersionNumber,
    };
};
